import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { augmentErrorResponse } from './auth-interceptor-helper';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private spinner: NgxSpinnerService) { }

    private handleError(error: HttpErrorResponse, isPersisMission: boolean = false) {
        const errorResponse = augmentErrorResponse(error);
        if (error.status === 401 || error.status === 403) {
            this.authService.logout();
            this.spinner.hide();
            if (!isPersisMission) {
                return EMPTY;
            }
        }
        return throwError(errorResponse);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            const jwt = this.authService.getAccessToken();
            const { url } = req;

            if (!jwt) {
                return next.handle(req).pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
            }

            const headers: { [key: string]: string } =
                req.body instanceof FormData
                    ? { Authorization: `Bearer ${jwt}` }
                    : {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${jwt}`,
                    };
            if (!url.includes('File/UploadImage')) {
                req = req.clone({
                    setHeaders: headers,
                });
            }

            return next.handle(req).pipe(catchError((error: HttpErrorResponse) => this.handleError(error)));
        }
        catch (error) {
            return next.handle(req).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true)));
        }
    }
}
